'use client';

import { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useReactiveAuthTokens } from '@/app/contexts';
import {
  getCurrentPersonalFilesCaseId,
  personalFilesCaseIdFromClaims,
  setCurrentPersonalFilesCaseId,
} from '@/shared/ad-hoc-case';

export function personalFilesCaseIdFromIdToken(
  idToken: string | null | undefined,
): string | null {
  if (!idToken) return null;
  try {
    return personalFilesCaseIdFromClaims(jwtDecode<Record<string, unknown>>(idToken));
  } catch {
    return null;
  }
}

/** Backend / S3 case id for the signed-in user's My Files prefix (token email). */
export function usePersonalFilesCaseId(): string | null {
  const { idToken } = useReactiveAuthTokens();
  const fromToken = useMemo(() => personalFilesCaseIdFromIdToken(idToken), [idToken]);
  if (fromToken && getCurrentPersonalFilesCaseId() !== fromToken) {
    setCurrentPersonalFilesCaseId(fromToken);
  }
  return fromToken ?? getCurrentPersonalFilesCaseId();
}
